module.exports = __webpack_public_path__ + "img/icon_04.c1f223da.png";